const theme = {
  colors: {
    main: '#003554',
    mainDark: '#003554',
    mainLight: '#006494',
    mainLighter: '#0582ca',
    textColor: '#333',
    whiteColor: '#fffaff',
    errorRed: '#E63946',
    shadow: 'rgba(0,0,0,.2)',
  },

  mediaQueries: {
    smallest: `only screen and (max-width: 25em)`,
    small: `only screen and (max-width: 37.5em)`,
    medium: `only screen and (max-width: 56em)`,
    large: `only screen and (max-width: 80em)`,
    largest: `only screen and (max-width: 90em)`,
  },
};

export default theme;